import { Component, OnInit } from '@angular/core';
import { GA404PageLoad } from '@analytics/classes/ga.error.class';
import { AnalyticsService } from '@analytics/services/analytics.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
})
export class NotFoundComponent implements OnInit {
  constructor(public analyticsService: AnalyticsService) {}
  ngOnInit() {
    this.analyticsService.eventEmitter(new GA404PageLoad().gaData);
  }
}
